import React from "react";
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhoneAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import logo from './logo.png';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                {/* Left Section: Information */}
                <div className="footer-info">
                    <div className="footer-logo">
                        <img src={logo} alt="Company Logo" className="logo" />
                    </div>

                    <div className="footer-item">
                        <FontAwesomeIcon icon={faMapMarkerAlt} className="footer-icon" />
                        <p>89 Hoang Minh Giam St., Hoa Xuan Ward, Cam Le District, Da Nang City, Viet Nam</p>
                    </div>

                    <div className="footer-item">
                        <FontAwesomeIcon icon={faPhoneAlt} className="footer-icon" />
                        <p>(+84) 905521785</p>
                    </div>

                    <div className="footer-item">
                        <FontAwesomeIcon icon={faEnvelope} className="footer-icon" />
                        <p>
                            <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>
                        </p>
                    </div>
                </div>

                {/* Right Section: Map */}
                <div className="footer-map">
                    <h4>Our Location</h4>
                    <iframe
                        title="Company Map"
                        width="100%"
                        height="200"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3835.4183840119326!2d108.20771517544506!3d15.991721484676637!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31421a416358a129%3A0x1979d963f7e4d152!2zODkgSG_DoG5nIE1pbmggR2nDoW0sIEhvw6AgWHXDom4csIEPhuqltIEzhu4csIMSQw6AgTuG6tW5nIDU1MDAwMCwgVmnhu4d0IE5hbQ!5e0!3m2!1svi!2s!4v1734764190697!5m2!1svi!2s&hl=en"
                        allowFullScreen=""
                        loading="lazy"
                    ></iframe>

                </div>
            </div>

            {/* Copyright Section */}
            <div className="text-column">
                <p className="copyright-text">&copy; 2023 Beta Japan Software, Co.</p>
            </div>
        </footer>
    );
};

export default Footer;
